import styled from 'styled-components';
import { HEADER_HEIGHT } from 'components/Page/Header/TopHeader/TopHeader';
import { theme } from 'styles';
import { Flex, Modal, MODAL_HEADER_HEIGHT } from 'UI';

export const SModal = styled(Modal)`
  .ant5-modal-body > div {
    margin: 0px !important;
  }

  .ant5-modal-content {
    height: ${() => `calc(100vh - ${HEADER_HEIGHT}px) !important`};
    overflow-y: auto;
    border-bottom-right-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  position: absolute;
  right: 8px;
  top: ${() => `${HEADER_HEIGHT - MODAL_HEADER_HEIGHT}px !important`};
  max-width: 900px;
`;

export const SDiv = styled.div`
  margin: 2px -24px 0px -24px !important;
  background-color: ${({ theme }) => theme.color.grey95};
  border-bottom: solid 1px ${({ theme }) => theme.color.grey85};
  border-top: solid 1px ${({ theme }) => theme.color.grey85};
  width: auto;
`;

export const SFlex = styled(Flex)`
  margin: 0;
  height: auto !important;
  flex: 1;
`;

export const RefSeller = styled(Flex)`
  padding: 20px;
  border: 1px solid ${theme.color.grey85};
  border-radius: 8px;
`;
